import { GetTigerXAccount, GetSym } from './tigerX.thunk'

export const tigerXAsyncActions = {
  GetTigerXAccount,
  GetSym,
}
